module.exports = __webpack_public_path__ + "static/img/laulilii-kit.aab8c5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laulilii-kit.jpg
// module id = 1j0o
// module chunks = 0